module.exports = __webpack_public_path__ + "static/media/extrait_validation_géné_X.01defc68.pdf";